import React from 'react';
import { createUseStyles } from 'react-jss';
import variables from '../../theme/variables';

const useStyles = createUseStyles(
    {
        headline: {
            fontFamily: variables.typography.segoe,
            fontSize: 24,
            lineHeight: '30px',
            fontWeight: 400,
            margin: 0,
            marginBottom: 20,

            '@media (min-width: 1024px)': {
                fontSize: 32,
                lineHeight: '40px',

                display: 'none',
            },
        },
    },
    { name: 'SecondaryHeadline' }
);

export default function SecondaryHeadline({ title }) {
    const classes = useStyles();

    return (
        <h2
            className={classes.headline}
            dangerouslySetInnerHTML={{ __html: title }}
        ></h2>
    );
}
